import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { NavBlockViewImpl } from './navblockview';
import { NavBlockCSSStyleImpl } from './navblockcss';

export interface NavBlockComponentProps extends UIComponentProps
{
   title: string;
   list: any[];
   links: any;
}

export class NavBlockComponent extends UIComponentImpl<NavBlockComponentProps, UIComponentState, UIDataModel>
{
    constructor(props: NavBlockComponentProps)
    {
        super(props);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new NavBlockViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new NavBlockCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/footer-native/navblockcomponent.tsx